import { User } from 'models';

type UserNameFields = Pick<User, 'firstName' | 'lastName'>;
type PartialUser = Partial<UserNameFields>;

export const getUsersFullName = (emptyValue: string, user?: PartialUser) =>
  user && (user.firstName || user.lastName)
    ? `${user.firstName} ${user.lastName}`.trim()
    : emptyValue;

/**
 * This uses the logic from data-layer to compute the fullName of a user.
 * @param user
 */
export function getFullName({ firstName, lastName, companyName }: User) {
  return firstName || lastName
    ? `${firstName} ${lastName}`.trim()
    : companyName || 'Unnamed User';
}
